import type {FunnelProgress, IWHIPage} from '@nib/types-session-api';
import {IWHIJoinState} from '../../store';
import _get from 'lodash/get';
import {IWHIPageIndex, IWHIPageList} from '../../../constants';

export const selectData = (state: IWHIJoinState): FunnelProgress => _get(state, 'session.session.funnelProgress', {} as FunnelProgress);
export const selectLastCompletedPageStepOrder = (state: IWHIJoinState): number => _get(state, 'session.session.funnelProgress.lastCompletedPage.stepOrder', 0);
export const getLastCompletedPage = (state: IWHIJoinState): IWHIPage => selectData(state).lastCompletedPage || {};
export const getActivePage = (state: IWHIJoinState): IWHIPage => selectData(state).activePage || IWHIPageList[IWHIPageIndex.COVER_DETAILS];
